import { setEmail } from "../../domain/subscribe/subscribeModel";
import { UpdateNewsletterStore, updateNewsletterUseCase } from "./updateNewsletterUseCase";

const setNewsletterEmailUseCase = (store: UpdateNewsletterStore, value: string) => 
updateNewsletterUseCase(store, value, setEmail);


export { setNewsletterEmailUseCase }